

















import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("login");

export default Vue.extend({
    name: "Language",
    data() {
        return {
            locale: "zh-CN",
            langKey: "tms-h5.lang"
        };
    },
    mounted() {
        const lang = localStorage.getItem(this.langKey) || "";
        if (["zh-CN", "en-US"].includes(lang)) {
            this.locale = lang;
        }
    },
    computed: {
        ...mapGetters(["loggedIn"])
    },
    methods: {
        safeGo(path): string {
            return this.loggedIn ? path : "/login";
        },
        selectLanguage(val: string) {
            localStorage.setItem("tms-h5.lang", val);
            this.$i18n.locale = val;
            return this.$router.push(this.safeGo("/my"));
        }
    }
});
